import { Controller } from "stimulus";
import EmblaCarousel from "embla-carousel";

const MOBILE_BREAKPOINT = 767;

export default class extends Controller {
  connect() {
    this.originalHTML = this.element.innerHTML;
    this._onResize = this.handleResize.bind(this);
    window.addEventListener("resize", this._onResize);
    this.applyForViewport();
  }

  disconnect() {
    window.removeEventListener("resize", this._onResize);
    this.destroyEmbla();
  }

  isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  handleResize() {
    const mobile = this.isMobile();
    if (mobile === this.currentMobile) return;
    this.applyForViewport();
  }

  applyForViewport() {
    this.destroyEmbla();
    this.element.innerHTML = this.originalHTML;
    this.currentMobile = this.isMobile();
    if (this.currentMobile) {
      this.buildMobile();
    }
  }

  buildMobile() {
    const lists = Array.from(this.element.querySelectorAll(".cgwm-features-list"));
    if (lists.length === 0) return;

    const viewport = document.createElement("div");
    viewport.className = "cgwm-features-embla";

    const container = document.createElement("div");
    container.className = "cgwm-features-embla__container";

    lists.forEach((list) => {
      const slide = document.createElement("div");
      slide.className = "cgwm-features-embla__slide";
      slide.appendChild(list);
      container.appendChild(slide);
    });

    viewport.appendChild(container);

    const dots = document.createElement("div");
    dots.className = "cgwm-features-dots";

    this.element.innerHTML = "";
    this.element.appendChild(viewport);
    this.element.appendChild(dots);

    this.embla = EmblaCarousel(viewport, {
      loop: false,
      align: "start",
      slidesToScroll: 1,
      containScroll: "trimSnaps",
    });

    this.buildDots(dots);
  }

  buildDots(dotsContainer) {
    const buttons = [];
    const snaps = this.embla.scrollSnapList();

    snaps.forEach((_, i) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "cgwm-features-dot";
      btn.setAttribute("aria-label", `Go to slide ${i + 1}`);
      btn.addEventListener("click", () => this.embla.scrollTo(i));
      dotsContainer.appendChild(btn);
      buttons.push(btn);
    });

    const update = () => {
      const selected = this.embla.selectedScrollSnap();
      buttons.forEach((b, i) => b.classList.toggle("is-active", i === selected));
    };

    update();
    this.embla.on("select", update);
    this.embla.on("reInit", update);
  }

  destroyEmbla() {
    if (this.embla) {
      this.embla.destroy();
      this.embla = null;
    }
  }
}
